import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import dateTimeHelper from '../../../Helpers/datetimeHelper';
import OfficeHelper from '../../../Helpers/ModelHelpers/OfficeHelper';
import UserService from '../../../Services/userService';

export default class TpClientPaymentsPrepaymentsSearchParams extends SearchParamsBase {
  initialize() {
    const userOffice = UserService.GetOfficeIdOfLoggedInUser();
    this.OfficeIds = OfficeHelper.GetDefaultOfficeIds(userOffice);
    this.ClientNameOrId = '';
    this.UseEntryDateRange = false;
    this.EntryBefore = dateTimeHelper.indefiniteDateValue();
    this.EntryAfter = dateTimeHelper.indefiniteDateValue();
    this.UsePaymentInstrumentDateRange = false;
    this.PaymentInstrumentBefore = dateTimeHelper.indefiniteDateValue();
    this.PaymentInstrumentAfter = dateTimeHelper.indefiniteDateValue();
    this.PaymentRef = '';
    this.AmountPaidMoreThan = '';
    this.AmountPaidLessThan = '';
    this.Reversed = '';
    this.PaymentListType = '';
    this.TpClientInvoiceId = null;
    this.TpClientPaymentId = null;
  }

  static fieldsInSearchBox = [
    { fieldName: 'TpClientPaymentId', label: 'Payment ID', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'ClientNameOrId', label: 'Client Name or ID', className: 'col-4', type: InputTypesEnum.Text },
    {
      fieldName: 'UseEntryDateRange',
      label: 'Entry Date Range',
      className: 'col-4',
      type: InputTypesEnum.OnOff,
    },
    {
      fieldName: 'EntryAfter',
      label: 'Entry On or After',
      className: 'col-4',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseEntryDateRange,
    },
    {
      fieldName: 'EntryBefore',
      label: 'Entry On or Before',
      className: 'col-4',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseEntryDateRange,
    },
    {
      fieldName: 'UsePaymentInstrumentDateRange',
      label: 'Payment Instrument Date Range',
      className: 'col-4',
      type: InputTypesEnum.OnOff,
    },
    {
      fieldName: 'PaymentInstrumentAfter',
      label: 'Payment Instrument On or After',
      className: 'col-4',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UsePaymentInstrumentDateRange,
    },
    {
      fieldName: 'PaymentInstrumentBefore',
      label: 'Payment Instrument On or Before',
      className: 'col-4',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UsePaymentInstrumentDateRange,
    },
    { fieldName: 'PaymentRef', label: 'Payment Ref.', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'Reversed', label: 'Reversed?', className: 'col-4', type: InputTypesEnum.EmptyYesNoSelect },
    {
      fieldName: 'AmountPaidLessThan',
      label: 'Amount Paid Less Than',
      className: 'col-4',
      type: InputTypesEnum.Number,
    },
    {
      fieldName: 'AmountPaidMoreThan',
      label: 'Amount Paid More Than',
      className: 'col-4',
      type: InputTypesEnum.Number,
    },
    {
      fieldName: 'OfficeIds',
      label: 'Office',
      className: 'col-4',
      type: InputTypesEnum.OfficeOrGroupMultiSelect,
    },
  ];

  static iconName = 'fa-solid fa-search';
  static saveType = 'TpClientPaymentsPrepaymentsSearchParams';
}
